import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import FeesBreakdownDetailsIcon from './fees-breakdown-details';
import LinkWithPopover from '../../link-with-popover';
import PriceRanges from '../../price-ranges';
import money, { format } from '../../../lib/money';
import Purchase from '../../../lib/purchase';

class YourSharePricingDetails extends Component {
  get shareAmount() { return money(this.props.shareAmount); }

  isPerSlot() {
    return Purchase.isFixedPerPerson(this.props.splitType);
  }

  renderFeesBreakdownDetails() {
    const { feesAmount, shareAmount, costPerSlot, claimedSlots, amount } = this.props;

    return (
      <FeesBreakdownDetailsIcon
        claimedSlots={claimedSlots}
        amount={amount}
        shareAmount={shareAmount}
        costPerSlot={costPerSlot}
        feesAmount={feesAmount}
      />
    );
  }

  renderPricingDetails() {
    return (
      <LinkWithPopover name="pricing-details" text="Details" placement="bottom">
        <PriceRanges
          perPerson={this.isPerSlot()}
          totalCosts={this.props.costRange}
        />
      </LinkWithPopover>
    );
  }

  render() {
    return (
      <div className="your-share-pricing-details">
        <div>
          <FormattedMessage
             id="yourShare.pricingDetails.yourShare"
             defaultMessage="Your share"
           /> {this.renderFeesBreakdownDetails()}
        </div>
        <div>
          <h2 className="mb-0">{format(this.shareAmount)}</h2>
          <p className="small-print">
            {Purchase.isTotal(this.props.costType) &&
              <FormattedMessage
                id="yourShare.pricingDetails.orLess"
                defaultMessage="or less if more join"
              />
            }
            {' '}
            {this.renderPricingDetails()}
          </p>
        </div>
      </div>
    );
  }
}

export default YourSharePricingDetails;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/your-share.pricing-details.js